import React, { Component } from 'react';

class ManagePasswordInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentValue: '',
            inputValue: props.value || '',
            isPasswordVisible: false, // New state for password visibility
        };

        this.onChangeFn = this.onChangeFn.bind(this);
        this.onBlurFn = this.onBlurFn.bind(this);
        this.onFocusFn = this.onFocusFn.bind(this);
        this.onKeyDownFn = this.onKeyDownFn.bind(this);
        this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this); // Bind new method
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.value !== prevProps.value && this.props.value !== prevState.inputValue) {
            this.setState({
                inputValue: this.props.value || '',
            });
        }
        if ((this.props.menuTitle && prevState.inputValue.length < 1 && this.state.inputValue.length < 1 && this.props.value) || 
            (this.props.menuTitle && this.state.inputValue.length < 1 && this.props.value?.length > 1)) {
            this.setState({
                inputValue: this.props.value,
            });
        }
    }

    onChangeFn(e) {
        const currentValue = this.state.inputValue;

        this.setState({
            inputValue: e.target.value,
            currentValue: currentValue || '',
        });

        if (this.props.onChange) {
            this.props.onChange(e);
        }
    }

    onBlurFn(e) {
        e.oldValue = this.state.currentValue;

        if (this.props.onBlur && !this.waitingOnFinishTyping) {
            this.props.onBlur(e);
        }
    }

    onFocusFn(e) {
        this.setState({ currentValue: e.target.value });
    }

    onKeyDownFn(e) {
        if (e.keyCode === 13 && this.props.onReturnDown && !this.waitingOnFinishTyping) {
            this.props.onReturnDown(e);
        }
    }

    togglePasswordVisibility() {
        this.setState((prevState) => ({
            isPasswordVisible: !prevState.isPasswordVisible,
        }));
    }

    render() {
        const {
            successErrorClass,
            name,
            type,
            placeholder,
            multiline,
            onFocus,
            maxLength,
            className,
            autoFocus,
            id,
            disabled,
            refInput,
            autoComplete,
        } = this.props;

        const { isPasswordVisible, inputValue } = this.state;

        const dataqa = this.props.dataqa || this.props.id;
        const inputType = type === 'password' && (!isPasswordVisible || disabled) ? 'password' : 'text';
        const combinedClassName = successErrorClass ? `${className} ${successErrorClass}` : className;

        let inputElement = (
            <div>
                <input
                    ref={refInput}
                    type={inputType}
                    name={name}
                    value={inputValue}
                    placeholder={placeholder}
                    onChange={this.onChangeFn}
                    onBlur={this.onBlurFn}
                    onKeyDown={this.onKeyDownFn}
                    onFocus={onFocus}
                    maxLength={maxLength}
                    className={combinedClassName}
                    id={id}
                    disabled={disabled ? 'disabled' : ''}
                    data-qa={dataqa}
                    autoComplete={autoComplete}
                    autoFocus={autoFocus}
                    inputMode="text"
                    autoCorrect="off"
                    spellCheck="false"
                />
                {type === 'password' && inputValue.length > 0 && !disabled && (
                    <button
                        type="button"
                        onClick={this.togglePasswordVisibility}
                        style={{
                            position: 'absolute',
                            right: 10,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                        }}
                        disabled={disabled ? 'disabled' : ''}
                        aria-label="Toggle Password Visibility"
                    >
                        {isPasswordVisible ? 'Hide' : 'Show'}
                    </button>
                )}
            </div>
        );

        if (multiline) {
            inputElement = (
                <textarea
                    ref={refInput}
                    maxLength={maxLength}
                    name={name}
                    placeholder={placeholder}
                    value={inputValue}
                    onChange={this.onChangeFn}
                    onBlur={this.onBlurFn}
                    onFocus={onFocus}
                    data-qa={dataqa}
                    id={id}
                />
            );
        }

        return inputElement;
    }
}

export default ManagePasswordInput;